import { gql } from "@apollo/client";

export const LOAD_LOCATION_RULE_NOTES_QUERY = gql`
  query LoadLocationRuleNotes(
    $pickup: CustomerLocationStopInput!
    $dropoff: CustomerLocationStopInput!
    $dateTime: String
  ) {
    loadLocationRuleNotes(
      pickup: $pickup
      dropoff: $dropoff
      dateTime: $dateTime
    ) {
      tripNote
    }
  }
`;
